import { render, staticRenderFns } from "./DoordashButton.vue?vue&type=template&id=449ae024&"
import script from "./DoordashButton.vue?vue&type=script&lang=js&"
export * from "./DoordashButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports